import { useState } from 'react';

export const useApplicationForm = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    education: '',
    workExperience: '',
    resume: null,
    nightShift: '',
  });

  const handleChange = (e) => {
    const { name, type, value, files } = e.target;
    if (type === 'file') {
      setFormData((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      education: '',
      workExperience: '',
      resume: null,
      nightShift: '',
    });
  };

  return {
    showForm,
    setShowForm,
    formData,
    setFormData,
    handleChange,
    resetForm,
  };
};
